var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "table-responsive" }, [
      _c("table", [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.comentarios, function(comentario, index) {
            return _c(
              "tr",
              {
                key: index,
                class: {
                  "tr--pending": parseFloat(comentario.distancia) > 100
                }
              },
              [
                _c("td", [
                  _vm._v(
                    "\n            " +
                      _vm._s(comentario.usuario.nombre) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n            " +
                      _vm._s(comentario.fecha_comentario) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n            " +
                      _vm._s(comentario.comentario) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: comentario.coordenadas_comentario != null,
                          expression:
                            "comentario.coordenadas_comentario != null"
                        }
                      ],
                      staticClass: "btn-info btn--text",
                      on: {
                        click: function($event) {
                          return _vm.verMapa(comentario)
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-map-marker" }),
                      _c("span", [_vm._v(_vm._s(comentario.direccion))])
                    ]
                  )
                ])
              ]
            )
          }),
          0
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("cerrar")
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-times" }),
          _c("span", [_vm._v("Cerrar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h5", [_vm._v("Comentarios de venta")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Usuario")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha de comentario")]),
        _vm._v(" "),
        _c("th", [_vm._v("Comentario")]),
        _vm._v(" "),
        _c("th", [_vm._v("Dirección")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d7704c80", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7704c80","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ComentariosVenta.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-d7704c80","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ComentariosVenta.vue
// module chunks = 0